import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './en-US';
import ruRU from './ru-RU';
import deDE from './de-DE';
import esES from './es-ES'
import frFR from './fr-FR';
import itIT from './it-IT';
import jaJP from './ja-JP';
import koKP from './ko-KP';
import ptPT from './pt-PT';
import zhCN from './zh-CN';
import { ILanguages } from '../interfaces';

export const LANGUAGES: ILanguages[] = [
    {
        id: 'ru',
        title: 'Русский',
    },
    {
        id: 'en',
        title: 'English',
    },
    {
        id: 'de',
        title: 'Deutsch',
    },
    {
        id: 'es',
        title: 'Español',
    },
    {
        id: 'fr',
        title: 'Français'
    },
    {
        id: 'it',
        title: 'Italiano',
    },
    {
        id: 'ja',
        title: '日本語',
    },
    {
        id: 'ko',
        title: '한국어'
    },
    {
        id: 'pt',
        title: 'Português',
    },
    {
        id: 'zh',
        title: '中文',
    }
];

export const LANGUAGES_PRICES: ILanguages[] = [
    {
        id: 'ru',
        title: 'Русский',
    },
    {
        id: 'en',
        title: 'English',
    },
];

const resources: any = {
    'en': enUS,
    'ru': ruRU,
    'de': deDE,
    'es': esES,
    'fr': frFR,
    'it': itIT,
    'ja': jaJP,
    'ko': koKP,
    'pt': ptPT,
    'zh': zhCN,
};

export const getDefaultLng = (): string => {
    const path = window.location.pathname;

    if (path) {
        const pathSegments: string[] = path.split('/');

        if (pathSegments && pathSegments?.length && pathSegments[2] && resources[pathSegments[2]]) {
            window.localStorage.setItem('i18nextLng', pathSegments[2]);

            return pathSegments[2];
        }
    }

    if (window.localStorage.i18nextLng) {
        return window.localStorage.i18nextLng;
    }

    const preferredLanguage: string = navigator.languages ? navigator.languages[0] : navigator.language;

    if (preferredLanguage && resources[preferredLanguage]) {
        return preferredLanguage;
    }

    return 'en';
}

i18n.use(initReactI18next).init({
    resources,
    lng: getDefaultLng(),
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;
